"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tree = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Arrow = _interopRequireDefault(require("./Arrow.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _union2 = _interopRequireDefault(require("lodash/union"));
var _classnames = _interopRequireDefault(require("classnames"));
var _t = _interopRequireDefault(require("t"));
var _md = _interopRequireDefault(require("md5"));
var _store = _interopRequireDefault(require("store"));
var _reactRedux = require("react-redux");
var _builder = require("../../../selectors/builder.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Tree = /*#__PURE__*/function (_React$Component) {
  _inherits(Tree, _React$Component);
  var _super = _createSuper(Tree);
  function Tree(props, context) {
    var _this;
    _classCallCheck(this, Tree);
    _this = _super.call(this, props, context);
    _defineProperty(_assertThisInitialized(_this), "getParentsForSelected", function () {
      var selected = _this.getSelectedElement();
      if (!selected) {
        return [];
      }
      var parentsForSelected = null;
      var loopChildren = function loopChildren(branch) {
        var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        // Parents have been already found
        if (parentsForSelected) {
          return;
        }
        if (branch.id === selected) {
          parentsForSelected = parents;
          return;
        }
        if (branch.children) {
          branch.children.forEach(function (child) {
            return loopChildren(child, [].concat(_toConsumableArray(parents), [branch.id]));
          });
        }
      };
      var tree = _this.prepareTree();
      tree.forEach(function (child) {
        return loopChildren(child);
      });
      return parentsForSelected || [];
    });
    _defineProperty(_assertThisInitialized(_this), "generateHash", function () {
      // Generate unique hash for the page+tree
      var str = window.location.hostname + window.location.pathname + _this.props.name;
      return 'tree_' + (0, _md["default"])(str);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleExpand", function (id) {
      _this.setState({
        expandedList: (0, _xor2["default"])(_this.state.expandedList, [id])
      }, _this.saveInStorage);
    });
    _defineProperty(_assertThisInitialized(_this), "saveInStorage", function () {
      _store["default"].set(_this.generateHash(), {
        expandedList: _this.state.expandedList
      });
    });
    _defineProperty(_assertThisInitialized(_this), "removeDeprecatedDataConnectors", function (tree) {
      var selected = _this.getSelectedElement();
      var adjustedTree = _t["default"].filter(tree, function (node, parent) {
        if (node.deprecated && node.id !== selected) {
          return false;
        }
        return _objectSpread({}, node);
      });
      return adjustedTree;
    });
    _defineProperty(_assertThisInitialized(_this), "prepareTree", function () {
      var _this$props = _this.props,
        filter = _this$props.filter,
        dataConnectorsTree = _this$props.dataConnectorsTree;
      var tree = filter ? _t["default"].filter(dataConnectorsTree, filter) : dataConnectorsTree;
      tree = _this.removeDeprecatedDataConnectors(tree);
      return tree;
    });
    _defineProperty(_assertThisInitialized(_this), "renderDisabled", function (child) {
      var reasons = {
        self: "Can't connect to itself",
        noData: 'No data connectors',
        circular: "Can't create circular connections"
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_style["default"].title, " ").concat(_style["default"].disabled),
        title: reasons[child.disabledReason]
      }, child.icon && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].icon
      }, child.icon), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].textOverflow
      }, child.title), child.type && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].type
      }, "(", child.type, ")"));
    });
    _defineProperty(_assertThisInitialized(_this), "renderChildren", function (branch) {
      var expandedList = _this.state.expandedList;
      var onSelect = _this.props.onSelect;
      var selected = _this.getSelectedElement();
      return /*#__PURE__*/_react["default"].createElement("div", null, branch.map(function (child) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: child.id
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].child
        }, child.children && /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
          expanded: expandedList.includes(child.id),
          onClick: _this.toggleExpand.bind(_assertThisInitialized(_this), child.id)
        }), child.disabled ? _this.renderDisabled(child) : /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])([_style["default"].title, _defineProperty({}, _style["default"].selectable, child.value), _defineProperty({}, _style["default"].selected, selected === child.id)]),
          onClick: child.children ? _this.toggleExpand.bind(_assertThisInitialized(_this), child.id) : onSelect.bind(null, child.value)
        }, child.icon && /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].icon
        }, child.icon), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].textOverflow
        }, child.title), child.type && /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].type
        }, "(", child.type, ")"))), child.children && expandedList.includes(child.id) && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].childrenWrapper
        }, _this.renderChildren(child.children)));
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "getSelectedElement", function () {
      var selectedDataConnector = _this.props.selectedDataConnector;
      if (!selectedDataConnector || !['flow', 'dynamic'].includes(selectedDataConnector.category)) {
        return null;
      }
      var category = selectedDataConnector.category,
        id = selectedDataConnector.id,
        name = selectedDataConnector.name;
      return id ? "".concat(category, "_").concat(id, "_").concat(name) : "".concat(category, "_").concat(name);
    });
    var saved = _store["default"].get(_this.generateHash());
    var savedExpandedList = saved && saved.expandedList ? saved.expandedList : [];
    var selectedExpandedList = _this.getParentsForSelected();
    _this.state = {
      // If we've already picked one then show only expanded parent components
      expandedList: selectedExpandedList.length > 0 ? selectedExpandedList : (0, _union2["default"])(savedExpandedList, props.expandedList, selectedExpandedList)
    };
    return _this;
  }
  _createClass(Tree, [{
    key: "render",
    value: function render() {
      var selected = this.getSelectedElement();
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].treeWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].childrenWrapper
      }, this.renderChildren(this.prepareTree()))), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-sm btn-primary",
        disabled: !selected,
        onClick: this.props.handlePicking
      }, "Select"));
    }
  }]);
  return Tree;
}(_react["default"].Component);
exports.Tree = Tree;
_defineProperty(Tree, "propTypes", {
  name: _propTypes["default"].string,
  dataConnectorsTree: _propTypes["default"].array.isRequired,
  selectedDataConnector: _propTypes["default"].object,
  filter: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  handlePicking: _propTypes["default"].func,
  expandedList: _propTypes["default"].array
});
_defineProperty(Tree, "defaultProps", {
  onSelect: function onSelect() {},
  expandedList: []
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    dataConnectorsTree: (0, _builder.getDataConnectorsTree)(state.flow.builder)
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(Tree);
exports["default"] = _default;